<template>
    <div
        class="inline-block rounded-md py-1 px-3 text-sm transition-all duration-100"
        :class="{
            'bg-green-200 text-green-700': status === 'active',
            'bg-blue-200 text-blue-700': status === 'upcoming',
            'bg-red-200 text-red-700': status === 'inactive',
        }"
    >
        {{ name }}
        <CheckIcon class="inline-block pl-1 w-4 h-4" v-if="status === 'active'" />
        <div class="inline-block ml-1 w-2 h-2 bg-blue-500 ring-3 ring-blue-400 rounded-full" v-if="status === 'upcoming'"></div>
        <BellIcon class="inline-block pl-1 w-4 h-4" v-if="status === 'inactive'" />
    </div>
</template>

<script>
import { BellIcon, CheckIcon } from "@heroicons/vue/outline";

export default {
    props: {
        status: String,
        name: String,
    },
    components: {
        BellIcon,
        CheckIcon,
    },
}
</script>
